import { useRef } from 'react';
import { useInView } from 'framer-motion';
import theme from 'config/theme';
import { Link } from 'components/Link';
import OrbsContainer from 'components/LottieElements/OrbsContainer';
import { FadeText, FadeContainer } from 'components/CustomAnimations';

export const ReachOut = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <OrbsContainer jsonType="contact_module">
      <div className="reach-out-container" ref={sectionRef}>
        <div className="reach-out-title">
          <FadeText inViewTrigger className="eyebrow-text" text="Reach out" />
          <FadeText inViewTrigger delay={1} className="h2-dtm" text="Want to learn more?" />
        </div>
        <div className="reach-out-items">
          <FadeContainer className="reach-out-item" animateNow={isInView} delay={2.2}>
            <div className="reach-out-item-content">
              <FadeText className="h3-dtm" text="Careers" />
              <FadeText className="body-text" text="Interested in joining our team?" />
              <Link to="/contact" target="_blank" $color={theme.colors.white}>
                Drop your resume here
              </Link>
            </div>
          </FadeContainer>

          <FadeContainer className="reach-out-item" animateNow={isInView} delay={2.5}>
            <div className="reach-out-item-content">
              <FadeText className="h3-dtm" text="General" />
              <FadeText
                className="body-text"
                text="Have questions about Oath or how to use our platform?"
              />
              <Link
                to="https://helpcenter.oath.vote/oath-help-center"
                target="_blank"
                $color={theme.colors.white}
              >
                View our Help Center
              </Link>
            </div>
          </FadeContainer>

          <FadeContainer className="reach-out-item" animateNow={isInView} delay={3}>
            <div className="reach-out-item-content">
              <FadeText className="h3-dtm" text="Media" />
              <FadeText className="body-text" text="Questions on press or PR?" />
              <Link to="/contact" target="_blank" $color={theme.colors.white}>
                Contact us here
              </Link>
            </div>
          </FadeContainer>

          <FadeContainer className="reach-out-item" animateNow={isInView} delay={3.5}>
            <div className="reach-out-item-content">
              <FadeText className="h3-dtm" text="Partnerships" />
              <FadeText
                className="body-text"
                text="Is your organization looking to use Oath's fundraising tools?"
              />
              <Link
                to="https://airtable.com/appqq0c5KStOtf9pg/paghFLDqbigvqKbF2/form"
                target="_blank"
                $color={theme.colors.white}
              >
                Contact Partner Success here
              </Link>
            </div>
          </FadeContainer>
        </div>
      </div>
    </OrbsContainer>
  );
};
